import { motion } from 'framer-motion';
import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: 'https://images.unsplash.com/photo-1642844819197-5f5f21b89ff8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkZW50YWwlMjBjbGluaWMlMjBpbnRlcmlvciUyMGJyaWdodCUyMGNsZWFuJTIwcmVjZXB0aW9ufGVufDB8fHx8MTc2ODc3NDc1NXww&ixlib=rb-4.1.0&q=85',
      title: 'Clinic Reception',
      category: 'Interior'
    },
    {
      url: 'https://images.unsplash.com/photo-1631596577204-53ad0d6e6978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMGRlbnRpc3QlMjB0cmVhdGluZyUyMHBhdGllbnQlMjBzbWlsZSUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzY4Nzc0NzU3fDA&ixlib=rb-4.1.0&q=85',
      title: 'Patient Care',
      category: 'Treatment'
    },
    {
      url: 'https://images.unsplash.com/photo-1565090567208-c8038cfcf6cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxmcmllbmRseSUyMGRlbnRpc3QlMjB0cmVhdGluZyUyMHBhdGllbnQlMjBzbWlsZSUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzY4Nzc0NzU3fDA&ixlib=rb-4.1.0&q=85',
      title: 'Smile Consultation',
      category: 'Treatment'
    },
    {
      url: 'https://images.unsplash.com/photo-1738992696295-ce6b85532ca9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGluZGlhbiUyMGZhbWlseSUyMHNtaWxpbmclMjBoZWFsdGh5JTIwdGVldGglMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njg3NzQ3NjB8MA&ixlib=rb-4.1.0&q=85',
      title: 'Happy Patients',
      category: 'Results'
    },
    {
      url: 'https://images.unsplash.com/photo-1659352790654-058e9077a4f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGluZGlhbiUyMGZhbWlseSUyMHNtaWxpbmclMjBoZWFsdGh5JTIwdGVldGglMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njg3NzQ3NjB8MA&ixlib=rb-4.1.0&q=85',
      title: 'Family Dentistry',
      category: 'Results'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_492015e1-693c-4b93-9925-0425-0425bdd75ac8/artifacts/wqdiunqi_file_00000000615871faa3e076794ff10c47.jpg',
      title: 'Vijaya Dental Clinic',
      category: 'Branding'
    }
  ];

  const categories = ['All', 'Interior', 'Treatment', 'Results', 'Branding'];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredImages = activeCategory === 'All'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <div data-testid="gallery-page">
      <section className="pt-32 pb-20 bg-gradient-to-r from-blue-50 to-cyan-50" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <span className="text-sm font-bold text-primary uppercase tracking-widest">Gallery</span>
            <h1 className="font-heading font-bold text-5xl sm:text-6xl text-slate-900 mt-4 mb-6">
              Our Clinic & Services
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Take a virtual tour of our modern dental clinic and see the care we provide
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white" data-testid="gallery-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                data-testid={`category-${category.toLowerCase()}`}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeCategory === category
                    ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
                onClick={() => setSelectedImage(image)}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-80 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-white font-heading font-bold text-xl">{image.title}</p>
                    <p className="text-white/80 text-sm">{image.category}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-slate-900/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="image-modal"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="relative max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              data-testid="close-modal-button"
              className="absolute -top-12 right-0 text-white hover:text-primary transition-colors text-4xl"
            >
              Ã—
            </button>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="mt-4 text-center">
              <p className="text-white font-heading font-bold text-2xl">{selectedImage.title}</p>
              <p className="text-white/70">{selectedImage.category}</p>
            </div>
          </motion.div>
        </div>
      )}

      <section className="py-20 bg-slate-50" data-testid="visit-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-heading font-bold text-4xl text-slate-900 mb-6">
              Visit Our Clinic
            </h2>
            <p className="text-xl text-slate-600 mb-8">
              Experience our modern, comfortable environment in person
            </p>
            <a
              href="https://maps.google.com/?q=opp.+Railway+Station,+New+Shahupuri,+Kolhapur,+Maharashtra+416001"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-directions-button"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-primary to-secondary text-white font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              Get Directions
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
